import StateType from './state.type';

export default {
  loading: false,
  brands: [],
  total: 0,
} as StateType;
